import React from 'react';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';
import { useRecommendedProducts } from './use-recommended-products';

type MostPurchasedSectionProps = {
  dispensaryId: string;
};

export function MostPurchasedCarousel({ dispensaryId }: MostPurchasedSectionProps): JSX.Element | null {
  const { products, loading, error } = useRecommendedProducts({ dispensaryId });
  const label = `Buy It Again`;

  if (!loading && (error || !products.length)) {
    return null;
  }

  return <ProductCarousel products={products} isLoading={loading} title={label} />;
}
